import React, { useEffect, useState } from 'react';
import { LetterService } from '../../../../Services/Manage/LetterService';
import { Button, Card, Select, Space } from 'antd';
import useMessage from 'antd/es/message/useMessage';

const ListALLTC = ({ onEdit }) => {
  const [data, setData] = useState([]);
  const [message, msgcontx] = useMessage();

  const getAllData = async () => {
    try {
      const response = await LetterService.getAllTC();
      setData(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (record) => {
    try {
      const request = await LetterService.deleteTC(record.id);
      if (request.status) {
        message.success(request.message);
        getAllData();
      } else {
        message.error(request.message);
      }
    } catch (error) {
      console.log(error);
      message.warning(error);
    }
  };

  const handleChange = async (value, item) => {
  
    const status = { status: value }
    try {
      const request = await LetterService.patchTC(item.id, status);
      if (request.status) {
        message.success(request.message);
        getAllData();
      } else {
        message.error(request.message);
      }
    } catch (error) {
      console.log(error);
      message.warning(error);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);

  return (
    <div>
      {msgcontx}
      {data.map((item) => (
        <div
          style={{
            marginBottom: '15px'
          }}
        >
          <Card
            key={item.id}
            title={item.tag}
            extra={
              <Space>
                <Select
                  size="large"
                  value={item.status}
                  onChange={(value) => handleChange(value, item)}
                  placeholder="Select status"
                  style={{ width: 150 }}
                  options={[
                    {
                      label: <span style={{ color: "red" }}>Draft</span>,
                      value: "draft",
                    },
                    {
                      label: <span style={{ color: "green" }}>Active</span>,
                      value: "active",
                    },
                  ]}
                />
                <Button size='large' onClick={() => onEdit(item)}>Edit</Button>
                <Button size='large' danger onClick={() => handleDelete(item)}>Delete</Button>
              </Space>
            }
          >
      <div
  className="tandc-content"
  dangerouslySetInnerHTML={{ __html: item.data }}
/>

          </Card>
        </div>
      ))}
    </div>
  );
};

export default ListALLTC;
